import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import { FlexColumn } from "../../../../Common/Styles";
import { StudioProps } from "./Studio";

const CardLayout = ({ children, title }: StudioProps.CardLayoutProps) => {
  const { typography } = useTheme();
  return (
    <Container $gapInPx={8}>
      <Components.Text
        text={title}
        style={{ tokenStyle: typography.Heading.S }}
        fontWeight="font-weight-semibold"
        lineHeight="line-height-300"
      />
      {children}
    </Container>
  );
};

export default CardLayout;

const Container = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
`;
